import { v4 as uuidv4 } from "uuid";

export function debounceFn(func, timeout = 300) {
	let timer;
	return (...args) => {
		clearTimeout(timer);
		timer = setTimeout(() => {
			func.apply(this, args);
		}, timeout);
	};
}

export function throttleFn(cb, delay) {
	let wait = false;

	return (...args) => {
		if (wait) {
			return;
		}

		cb(...args);
		wait = true;
		setTimeout(() => {
			wait = false;
		}, delay);
	};
}

export function createIntervalObjects(interval) {
	var result = [];

	for (var i = 1; i <= interval; i++) {
		var obj = {
			_id: uuidv4(),
			description: i + " " + (i === 1 ? "day" : "days"),
		};

		result.push(obj);
	}

	return result;
}

/**
 * @param {string | undefined | null} phoneNumber
 * @returns {string}
 */
export const maskPhoneNumber = (phoneNumber) => {
	if (phoneNumber) {
		const regex = /(\d{3})(\d{3})(\d{4})/;
		return phoneNumber.replace(regex, "($1) $2-$3");
	}

	return "";
};
